"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var ProgramHero = function ProgramHeroComponent(_ref) {
  var dataClient = _ref.dataClient,
      pageData = _ref.pageData;
  var program_name = pageData.program_name,
      program_icon = pageData.program_icon,
      hero_summary = pageData.hero_summary;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "program-hero-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "program-hero__row"
  }, program_icon.url && /*#__PURE__*/_react["default"].createElement("div", {
    className: "program-hero__icon-col"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "program-hero__icon",
    src: program_icon.url,
    alt: ""
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "program-hero__info-col"
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "program-hero__name"
  }, dataClient.textToMarkdown(program_name)), /*#__PURE__*/_react["default"].createElement("hr", {
    className: "program-hero__hr"
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "program-hero__summary"
  }, dataClient.textToMarkdown(hero_summary))))));
};

ProgramHero.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  pageData: _propTypes["default"].shape({}).isRequired
};
var _default = ProgramHero;
exports["default"] = _default;